var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show && _vm.hasImages)?_c('VueCompareImage',{attrs:{"leftImage":_vm.mountImageUrl(_vm.content.beforePicture, 'before'),"rightImage":_vm.mountImageUrl(_vm.content.afterPicture, 'after')}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05382c62","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/organisms/BeforeAfterImageComponent.vue
// module id = 1865
// module chunks = 5